// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import VueMeta from 'vue-meta';
import App from "./App";
import router from "./router";
import iView from "iview";
import "iview/dist/styles/iview.css";
import config from "../src/config"
import axios from "axios";
import "animate.css";
import 'tcplayer.js/dist/tcplayer.min.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min";
import moment from "moment";
import hls from "videojs-contrib-hls";
import VideoPlayer from "vue-video-player";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vCharts from 'v-charts';
Vue.use(vCharts);
Vue.use(ElementUI);
import tool from "./libs/tool";
Vue.use(VueMeta);
Vue.use(tool);
Vue.config.productionTip = false;
Date.prototype.toJSON = function() { return this.toLocaleString(); }
Vue.prototype.$config = config;
Vue.prototype.$axios = axios;
import 'lib-flexible';

require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

Vue.use(iView);
Vue.use(hls);
Vue.use(VideoPlayer);
Vue.prototype.$moment = moment;
Vue.prototype.$bus = new Vue();
//全局组件

import gotop from '@/components/gotop.vue';
Vue.component('gotop', gotop);

// import VCharts from 'v-charts';
// Vue.use(VCharts);

import goment from '@/components/webTop/webTopMenu.vue';
Vue.prototype.$goment = goment;

import gotlogin from '@/components/gotlogin.vue';
Vue.component('gotlogin', gotlogin);

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  };
  next();
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  axios,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js